export enum DataRangesEnum {
  Current         = '00000163-1000-0000-0000-000000000001',
  LastMonth       = '00000163-1000-0000-0000-000000000002',
  PreviousMonth   = '00000163-1000-0000-0000-000000000003',
  LastYear_MTD    = '00000163-1000-0000-0000-000000000004',
  CurrentQuarter  = '00000163-1000-0000-0000-000000000005',
  LastQuarter     = '00000163-1000-0000-0000-000000000006',
  PreviousQuarter = '00000163-1000-0000-0000-000000000007',
  LastYearQTD     = '00000163-1000-0000-0000-000000000008',
  CurrentYear     = '00000163-1000-0000-0000-000000000009',
  LastYear        = '00000163-1000-0000-0000-000000000010',
  PreviousYear    = '00000163-1000-0000-0000-000000000011',
  LastYearYTD     = '00000163-1000-0000-0000-000000000012',
  LIfeTime        = '00000163-1000-0000-0000-000000000013',
  UserDefined     = '00000163-1000-0000-0000-000000000014',
  Today           = '00000163-1000-0000-0000-000000000015',
  Yesterday       = '00000163-1000-0000-0000-000000000016',
}
